import { oneTimesUpdate } from "@domain/coupons"
import { OneTimesType } from "__generated__/graphql"
import type { PlaygroundRequest, PlaygroundResponse } from "./types"

// Codegen for admin-panel-v2 is manual; until `yarn codegen` is re-run the new
// enum member does not exist on the generated OneTimesType.
const RUN_PROMPT_PLAYGROUND = "RUN_PROMPT_PLAYGROUND" as OneTimesType

function errorResult(message: string): PlaygroundResponse {
  return {
    ok: false,
    error: message,
    model: "",
    output: "",
    resolvedSystemPrompt: "",
    resolvedQuery: "",
    unresolvedVariables: [],
    latencyMs: 0,
    usage: { inputToken: 0, outputToken: 0, amount: 0 }
  }
}

/**
 * Runs the prompt text currently in the editor against the live LLM.
 * Never rejects — a transport failure comes back as `ok: false` so an
 * autonomous suite keeps going.
 */
export async function runPromptOnce(
  request: PlaygroundRequest
): Promise<PlaygroundResponse> {
  try {
    const { isSuccess, errorMessage, data } = await oneTimesUpdate({
      type: RUN_PROMPT_PLAYGROUND,
      metaData: request
    })

    if (!isSuccess || !data) {
      return errorResult(String(errorMessage || "Request failed"))
    }

    const payload = (data.data as PlaygroundResponse[] | undefined)?.[0]
    if (!payload) {
      return errorResult("Empty response from API")
    }

    return payload
  } catch (error) {
    return errorResult(error instanceof Error ? error.message : String(error))
  }
}
